import JSEncrypt from 'jsencrypt/lib'
import CryptoJS from 'crypto-js';
import { support_language, translation } from './services';
import { alertRef } from '../App';

export function range(start, end) {
    return new Array(end - start + 1).fill().map((d, i) => i + start);
}

export const convertCost = (value) =>{
    if(value === undefined || value === null) return value;
    else if( !isFinite(value) ) return 0;
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const encrypt = (val) => {
    var encrpyt = new JSEncrypt();
    encrpyt.setPublicKey('MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAxW2/EDFV81VWYa2y8o+7f3rSj8+Uzaifzf2/k0Ilr9eP17RbnWRdQ/ntglzgh2xW/kgW/Uonuu4SxUixY6V+JNPQoOISe4BHw4H2kepuYwp4JhdVXyC+UfQhTAO3628bthD5P//uQBwLQU0KMJtE4GUxormEK2pi7VbaI4QojvKZwpNUGVWtS7TeZ6XerKu9xrNQoQnBVPZmcs6MV4imYseZw0Ux8Qizlcn9kuedENSU5Z8E05Iwd1POwgDsYNzrYlhXUT3yvbkMv33QEudTzFKZ1pG7cIbKTQKEPWYoUb39vtXrhT7i8NGGyAEfUp8j6bOwBpiyazKvLFOUanUC4uWiThMX4f8gCJax+GYV+y/Ixc2MJz1Mf3AXYNFtQIBiIaQNxDSBnV5Kn+QYLzrm6BM/AkBllS5AwlM+fylAk7Q7MaZlFldvTXyUQQLACpyv/kr1uc5A3m1THgNLgjqKQIUke4O5UXuW3Fj5KhiNXxlIpHutB6kbg+8Titjr6yLoawRPaFWh+ABh/2QJCfNfmMiLCsJK/pjN8FvaacOHhgX0ZH6PoOyvy1qQ+OAYQSNPerMD/fR33ypwLSwfaY3uLBXD6PgmVGC+RNO+ryI2jHGTnfh/FP7HfXyV+gW3599/zxMNs5edZDZTX1V817Ao1C0Av+kcE1ktwC87Tul7HuUCAwEAAQ==')
    //encrpyt.setPrivateKey('MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAu/aEB0McYuHJ1LqePW0DG//c6S8wcs6+Axgbf5nc9iYzoUobUhyiSoQSq2a/95I8I5aNGworfG8uwVkrgMQa9qKWhu4q1oaY5OOdOOw4KHheSPNN0NqAC4Pfwkop6zOJhgcbJ6DiJpca/1O7ZIQaQboTldX+fbAAlIsqzFT1vxPf9PWIwcSDOJQlw2SnifCKn52uVxukf6w8enXr/AhsgWbbkAhufziU3pLxeTdZyjw7J3WSG3gByzzUkkZUMf/BS/wsIK9iqQrQNH8Um1kZ4F+RV1myLOBVRj3na8wnTF0h2z8czWbK8XCPkE6gD4dc2SHS5/pRMVHVGgKkkl1pPKMew6Np/8TztaCZQ2rHovkUZxTX+y5ywxqXk7HE9xSrFFFt/Pnrc9o63zjVjepBWkfvDqOTUNDpJ+jPcG8RltGnkQgfiiMW/AukSnv4pRGiJm3iHIGkZO0H1jMSMVTkGLe32JljwVeSLTf5jS6GD14UFTePb4rfT6LCSV2rywrl6n7S+CsUe/pH3F6fbkGdw2yIhUxYqWvsgmWjP5dFpsX1PNToYOuZBl3Mazlty9B1kn9iKKJoxmLB4j2YpjmIk+69pSre/owDrUPi6yCLtO6Iw5mygcZ+bO/7mzcX4Mj45/5JqVebcZl89q2uiYLwOGOnU3YLP9I1JBf2D6sH3McCAwEAAQ==')
    //var signature = encrpyt.sign(val, CryptoJS.SHA512, "sha512");
    //var data = JSON.parse(val)
    //console.log(signature)
    var encrpyted = encrpyt.encrypt(val)
    return encrpyted
}

export const encPass = (val) => {
    var shaPass = CryptoJS.SHA512(val).toString();
    var encrpyted = encrypt(shaPass)
    return encrpyted
}

export const onlyNum = (val) => {
    return isNaN(parseInt(val.replace(/[^0-9\.]+/g, ''))) ? 0 : parseInt(val.replace(/[^0-9\.]+/g, ''))
}

export const convertBuisnessNum = ( number ) => {
    return number.replace(/([0-9]{3})([0-9]{2})([0-9]{4})/,"$1-$2-$3");
}

export const languageText = (text) => {
    if(typeof text === 'object') return text.ko;
    else return text;
}

export const languageInit = () => {
    let object = {ko: ''};
    support_language.forEach((item) => {
        object = {...object, [item.value]: ''};
    })
    return object;
}

export const onTranslation = async (trans_language, trans_data, trans_value) => {
    const return_translation = await translation(trans_language, trans_data);
    let tmp_data = {};
    await trans_value.forEach((item, index) => {
        if(typeof item === 'string')
            tmp_data = {...tmp_data, [item]: {ko: trans_data[index]}}
        else if(typeof item === 'object') {
            if(typeof tmp_data[item.value] === 'undefined') tmp_data[item.value] = [];
            tmp_data[item.value].push({...item.data, [item.key]: {ko: trans_data[index]}})
        }
    });
    trans_language.forEach((item, index) => {
        const findeIndex = return_translation.findIndex(element => element.language === item)
        if(findeIndex !== -1)
            trans_value.forEach((element, index) => {
                if(typeof element === 'string')
                    tmp_data = {...tmp_data, [element]: {...tmp_data[element], [item]: return_translation[findeIndex].text[index]}}
                else if (typeof element === 'object')
                    tmp_data[element.value][element.index][element.key][item] = return_translation[findeIndex].text[index]
            })
    });
    // return tmp_data;
    alertRef.current.showAlert({ title : `알림`, subWarnTitle : '번역기능을 준비중입니다. 준비되면 알려드릴게요!', isConfirm : true, confirmText : '확인', onConfirm : () => alertRef.current.hideAlert() })
    return;
};